import type { Theme, Components } from "@mui/material/styles";

// ----------------------------------------------------------------------
const MuiContainer: Components<Theme>["MuiContainer"] = {
	/** **************************************
	 * DEFAULT PROPS
	 *************************************** */
	defaultProps: {
		// maxWidth: 'xl',
	},
};

export const container = { MuiContainer };
